/* Hytz mk.II — frontend behaviors */
/* build: 2026-05-11-1955 — force CDN hash bump for sticky ATC fade fix */

/* ═══ Native Shopify policy pages — inject breadcrumb + eyebrow to match brand page header ═══ */
(function () {
  function enhancePolicyPage() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container || container.dataset.hyEnhanced) return;
    container.dataset.hyEnhanced = '1';

    var title = container.querySelector('.shopify-policy__title');
    if (!title) return;
    var h1 = title.querySelector('h1');
    var titleText = h1 ? h1.textContent.trim() : 'Policy';

    // Breadcrumb at the very top
    var crumb = document.createElement('div');
    crumb.className = 'hy-breadcrumb';
    crumb.innerHTML = '<a href="/">Home</a> <span>/</span> ' + titleText;
    container.insertBefore(crumb, title);

    // Yellow eyebrow above the title h1
    var eyebrow = document.createElement('div');
    eyebrow.className = 'hy-section-label';
    eyebrow.textContent = 'Legal';
    title.insertBefore(eyebrow, h1 || title.firstChild);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePolicyPage);
  } else {
    enhancePolicyPage();
  }
})();

/* ═══ Cart drawer position override — drop from nav PILL as a connected extension ═══ */
(function () {
  function positionCart() {
    var drawer = document.getElementById('hytz-cart-drawer');
    var inner = document.querySelector('.hytz-nav-inner');
    if (!drawer || !inner) return;
    var r = inner.getBoundingClientRect();
    drawer.style.position = 'fixed';
    drawer.style.top = r.bottom + 'px'; // touch nav pill bottom (no gap)
    drawer.style.left = r.left + 'px';
    drawer.style.width = r.width + 'px';
    drawer.style.right = 'auto';
    drawer.style.maxHeight = 'calc(100vh - ' + (r.bottom + 16) + 'px)';
  }
  window.hytzPositionCart = positionCart;
  window.addEventListener('resize', positionCart, { passive: true });
  window.addEventListener('scroll', positionCart, { passive: true });
  // Re-sync after nav's shrink/grow transition settles (width/max-width + top + height)
  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.querySelector('.hytz-nav');
    var inner = document.querySelector('.hytz-nav-inner');
    function onNavSettle(e) {
      if (['top', 'max-width', 'height', 'padding'].indexOf(e.propertyName) === -1) return;
      positionCart();
    }
    if (nav) nav.addEventListener('transitionend', onNavSettle);
    if (inner) inner.addEventListener('transitionend', onNavSettle);
  });
  var observer = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        var d = m.target;
        var nav = document.querySelector('.hytz-nav');
        if (d.classList.contains('active')) {
          positionCart();
          if (nav) nav.classList.add('cart-open');
        } else {
          if (nav) nav.classList.remove('cart-open');
        }
      }
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    var d = document.getElementById('hytz-cart-drawer');
    if (d) observer.observe(d, { attributes: true, attributeFilter: ['class'] });
  });
})();

/* ═══ Mobile menu toggle — drops from nav pill like the cart drawer ═══ */
(function () {
  var hamburger = document.getElementById('hytz-nav-hamburger');
  var menu = document.getElementById('hy-mobile-menu');
  var overlay = document.getElementById('hy-mobile-menu-overlay');
  var nav = document.querySelector('.hytz-nav');
  if (!hamburger || !menu || !overlay || !nav) return;

  function positionMenu() {
    var inner = document.querySelector('.hytz-nav-inner');
    if (!inner || !menu) return;
    var r = inner.getBoundingClientRect();
    menu.style.position = 'fixed';
    menu.style.top = r.bottom + 'px';
    menu.style.left = r.left + 'px';
    menu.style.width = r.width + 'px';
    menu.style.maxHeight = 'calc(100vh - ' + (r.bottom + 16) + 'px)';
  }
  function openMenu() {
    // Mutex — if cart drawer is open, close it first so only one panel shows at a time
    var cart = document.getElementById('hytz-cart-drawer');
    var cartOverlay = document.getElementById('hytz-cart-overlay');
    if (cart && cart.classList.contains('active')) {
      cart.classList.remove('active');
      if (cartOverlay) cartOverlay.classList.remove('active');
      nav.classList.remove('cart-open');
    }
    positionMenu();
    menu.classList.add('active');
    overlay.classList.add('active');
    nav.classList.add('menu-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menu.classList.remove('active');
    overlay.classList.remove('active');
    nav.classList.remove('menu-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  // Expose for cross-script mutex (cart-open handler calls this to close menu)
  window.hytzCloseMobileMenu = closeMenu;
  window.hytzMobileMenuIsOpen = function () { return menu.classList.contains('active'); };
  hamburger.addEventListener('click', function () {
    if (menu.classList.contains('active')) closeMenu();
    else openMenu();
  });
  overlay.addEventListener('click', closeMenu);
  // Close when a menu link is clicked
  menu.addEventListener('click', function (e) { if (e.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('active')) closeMenu();
  });
  window.addEventListener('resize', function () {
    if (menu.classList.contains('active')) positionMenu();
  }, { passive: true });
  window.addEventListener('scroll', function () {
    if (menu.classList.contains('active')) positionMenu();
  }, { passive: true });
})();

/* ═══ Nav scroll-shrink ═══ */
(function () {
  var nav = document.querySelector('.hytz-nav');
  if (!nav) return;
  var threshold = 40;
  var raf = null;
  function update() {
    raf = null;
    if (window.scrollY > threshold) nav.classList.add('is-scrolled');
    else nav.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(update);
  }, { passive: true });
  update();
})();

/* ═══ Reviews marquee — JS-driven with drag + swipe, seamless loop ═══ */
(function () {
  var track = document.querySelector('.hy-reviews-track');
  if (!track) return;

  var offset = 0;                    // current translateX in px (negative = moved left)
  var speed = 45;                    // px / second (continuous drift)
  var lastTime = 0;
  var isDragging = false;
  var startX = 0;
  var startOffset = 0;
  var velocity = 0;
  var lastMoveX = 0;
  var lastMoveTime = 0;
  var inertiaRaf = null;

  // Liquid renders 2 identical copies. Remember the count of "original" children
  // (one set = half the initial children) so setWidth math stays correct after cloning.
  var originalChildCount = track.children.length;
  var cardsPerSet = originalChildCount / 2;
  var setWidth = 0;

  function recalc() {
    // setWidth = width of one set = total width ÷ (total children ÷ cardsPerSet)
    var sets = cardsPerSet ? track.children.length / cardsPerSet : 0;
    setWidth = sets ? track.scrollWidth / sets : 0;
  }

  function ensureEnoughContent() {
    // Seamless loop needs trackWidth ≥ viewport + setWidth so there's always
    // enough content ahead of the wrap point to fill the viewport.
    // Hidden tracks have scrollWidth=0; do NOT clone forever while display:none.
    if (!cardsPerSet || !setWidth || !track.scrollWidth) return false;
    var originalSetNodes = Array.from(track.children).slice(0, cardsPerSet);
    var guard = 0;
    while (track.scrollWidth < window.innerWidth + setWidth && guard < 12) {
      originalSetNodes.forEach(function (c) { track.appendChild(c.cloneNode(true)); });
      guard += 1;
    }
    return true;
  }

  recalc();
  if (!ensureEnoughContent()) return;

  // Take over from CSS animation only after the track is measurable. The
  // find-your-formula funnel renders review marquees inside display:none steps;
  // disabling CSS then cloning a zero-width track locks the page on load.
  track.style.animation = 'none';
  window.addEventListener('resize', function () {
    recalc();
    ensureEnoughContent();
  });
  // Recalc after fonts load in case card widths shift
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      recalc();
      ensureEnoughContent();
    });
  }

  function tick(t) {
    if (!lastTime) lastTime = t;
    var dt = (t - lastTime) / 1000;
    lastTime = t;

    if (!isDragging && !inertiaRaf) {
      offset -= speed * dt;
    }

    // Seamless wrap
    while (offset <= -setWidth) offset += setWidth;
    while (offset > 0) offset -= setWidth;

    track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  function onDown(e) {
    isDragging = true;
    startX = e.clientX;
    startOffset = offset;
    velocity = 0;
    lastMoveX = e.clientX;
    lastMoveTime = performance.now();
    track.classList.add('hy-is-dragging');
    try { track.setPointerCapture(e.pointerId); } catch (_) {}
    if (inertiaRaf) { cancelAnimationFrame(inertiaRaf); inertiaRaf = null; }
  }

  function onMove(e) {
    if (!isDragging) return;
    var dx = e.clientX - startX;
    offset = startOffset + dx;

    // Track velocity for inertia
    var now = performance.now();
    var dt = now - lastMoveTime;
    if (dt > 0) {
      velocity = (e.clientX - lastMoveX) / dt * 1000; // px / sec
    }
    lastMoveX = e.clientX;
    lastMoveTime = now;
  }

  function onUp(e) {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('hy-is-dragging');
    try { track.releasePointerCapture(e.pointerId); } catch (_) {}

    // Inertia: decay velocity, merge into continuous drift
    var v = velocity;
    function inertia() {
      if (Math.abs(v) < 5) { inertiaRaf = null; return; }
      offset += v * (1 / 60);
      v *= 0.94;
      while (offset <= -setWidth) offset += setWidth;
      while (offset > 0) offset -= setWidth;
      inertiaRaf = requestAnimationFrame(inertia);
    }
    if (Math.abs(velocity) > 50) inertiaRaf = requestAnimationFrame(inertia);
  }

  track.addEventListener('pointerdown', onDown);
  track.addEventListener('pointermove', onMove);
  track.addEventListener('pointerup', onUp);
  track.addEventListener('pointercancel', onUp);
})();

/* ═══ Product modal — flip + expand from lineup card ═══ */
(function () {
  var modal = document.getElementById('hy-modal');
  if (!modal) return;
  var card = document.getElementById('hy-modal-card');
  var currentSize = 'single';
  var currentHandle = null;
  var sourceCard = null;

  function formatSupp(sf) {
    if (!sf) return '';
    var html = '<div class="hy-supp-serving">Serving Size: ' + sf.serving + '</div>';
    html += '<div class="hy-supp-divider-thick"></div>';
    html += '<div class="hy-supp-row hy-supp-row-header"><span>Amount Per Serving</span><span>% DV</span></div>';
    html += '<div class="hy-supp-divider"></div>';
    sf.facts.forEach(function (f) {
      html += '<div class="hy-supp-row"><span>' + f.name + ' <strong>' + f.amount + '</strong></span><span>' + f.dv + '</span></div>';
      html += '<div class="hy-supp-divider"></div>';
    });
    html += '<div class="hy-supp-footnote">* Daily Value not established.</div>';
    return html;
  }

  function populate(handle) {
    var p = window.hytzV2Products && window.hytzV2Products[handle];
    var meta = window.hytzV2Meta && window.hytzV2Meta[handle];
    if (!p || !meta) return;
    card.style.setProperty('--c', 'var(' + meta.color + ')');
    var splashMap = window.hytzV2Splashes || {};
    if (splashMap[handle]) {
      card.style.setProperty('--splash', splashMap[handle]);
    }
    document.getElementById('hy-modal-substance').textContent = meta.substance;
    document.getElementById('hy-modal-name').textContent = meta.name;
    document.getElementById('hy-modal-meta').textContent = meta.caps;
    document.getElementById('hy-modal-desc').textContent = meta.desc;
    document.getElementById('hy-modal-timing').textContent = meta.timing;
    document.getElementById('hy-modal-supp-facts').innerHTML = formatSupp(meta.suppFacts);
    document.getElementById('hy-modal-pdp').href = p.url;

    // Preload all variant images so switching is instant (no network wait on click)
    Object.keys(p.images).forEach(function (key) {
      var u = p.images[key];
      if (u) { var pre = new Image(); pre.src = u; }
    });

    currentSize = 'three';
    setImage('three', p);

    // Populate variant pills + reset selection state to default (3-pack — Most
    // Popular). Variant click (handled in delegate) selects + swaps image; ATC
    // button submits the currently-selected pill — matches PDP UX.
    document.querySelectorAll('.hy-modal-price-pill').forEach(function (pill) {
      var size = pill.dataset.size;
      var v = p.variants[size];
      if (v) {
        pill.querySelector('[data-price]').textContent = v.price;
        pill.dataset.variantId = v.id;
        pill.style.display = '';
        pill.classList.toggle('is-selected', size === 'three');
      } else {
        pill.style.display = 'none';
        pill.classList.remove('is-selected');
      }
    });

    // Reset cart message + ATC button state from any prior open
    var msg = document.getElementById('hy-modal-cart-msg');
    if (msg) { msg.textContent = ''; msg.classList.remove('is-visible', 'is-success-pop', 'is-error'); }
    var atc = document.getElementById('hy-modal-cart-btn');
    if (atc) { atc.disabled = false; atc.style.opacity = ''; }

    // Reset accordions to closed
    document.querySelectorAll('.hy-modal-acc').forEach(function (a) { a.removeAttribute('open'); });
    // Reset scroll
    var scroll = document.getElementById('hy-modal-scroll');
    if (scroll) scroll.scrollTop = 0;
  }

  function setImage(size, p) {
    var url = p.images[size] || p.images.single;
    var container = document.getElementById('hy-modal-img');
    var existing = container.querySelector('img');
    if (!existing) {
      container.innerHTML = '<img src="' + url + '" alt="">';
      return;
    }
    if (existing.src === url || existing.src.indexOf(url) !== -1) return;
    // Fade out, swap src once the new image is decoded, fade in
    existing.classList.add('is-swapping');
    var next = new Image();
    next.onload = function () {
      existing.src = url;
      // Force repaint then fade back in
      requestAnimationFrame(function () {
        existing.classList.remove('is-swapping');
      });
    };
    next.onerror = function () {
      existing.classList.remove('is-swapping');
    };
    next.src = url;
  }

  function openModal(handle, srcCard) {
    currentHandle = handle;
    sourceCard = srcCard;
    populate(handle);

    var rect = srcCard.getBoundingClientRect();
    var maxW = Math.min(1180, window.innerWidth - 32);
    var maxH = Math.min(820, window.innerHeight - 32);
    var finalLeft = (window.innerWidth - maxW) / 2;
    var finalTop = (window.innerHeight - maxH) / 2;

    // Reset scroll hint state so it re-appears every time modal opens
    modal.classList.remove('has-scrolled');
    var hintEl = document.getElementById('hy-modal-scroll-hint');
    if (hintEl) hintEl.classList.remove('is-hidden');
    // Reset scroll position so hint threshold doesn't trigger immediately
    var scrollEl2 = document.getElementById('hy-modal-scroll');
    if (scrollEl2) scrollEl2.scrollTop = 0;

    // Visible + content hidden during flip
    modal.classList.add('is-visible', 'is-opening');
    modal.setAttribute('aria-hidden', 'false');
    // Scroll-lock via html overflow: simple, no scroll-position-reset flicker.
    // Compensates for scrollbar-width on <html> so page doesn't shift when scrollbar hides.
    var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (scrollbarW > 0) document.documentElement.style.paddingRight = scrollbarW + 'px';

    // Position card at source, no transition
    card.style.transition = 'none';
    card.style.left = rect.left + 'px';
    card.style.top = rect.top + 'px';
    card.style.width = rect.width + 'px';
    card.style.height = rect.height + 'px';
    card.style.transform = 'rotateY(0deg)';
    card.offsetHeight; // reflow

    // Animate to center + 360° flip
    card.style.transition = '';
    requestAnimationFrame(function () {
      card.style.left = finalLeft + 'px';
      card.style.top = finalTop + 'px';
      card.style.width = maxW + 'px';
      card.style.height = maxH + 'px';
      card.style.transform = 'rotateY(360deg)';
    });

    // After card lands, fade content in (round 12: trimmed 650→500ms for snappier feel)
    setTimeout(function () {
      modal.classList.remove('is-opening');
    }, 460);
  }

  function closeModal() {
    if (!sourceCard) return;
    modal.classList.add('is-closing');
    setTimeout(function () {
      var rect = sourceCard.getBoundingClientRect();
      card.style.left = rect.left + 'px';
      card.style.top = rect.top + 'px';
      card.style.width = rect.width + 'px';
      card.style.height = rect.height + 'px';
      card.style.transform = 'rotateY(0deg)';
    }, 100);
    setTimeout(function () {
      modal.classList.remove('is-visible');
      modal.classList.remove('is-closing');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
      card.style.transition = 'none';
      card.style.left = ''; card.style.top = ''; card.style.width = ''; card.style.height = '';
      card.style.transform = '';
      sourceCard = null;
      currentHandle = null;
    }, 580);
  }

  // Click delegation
  document.addEventListener('click', function (e) {
    // Modal close (X or backdrop)
    if (modal.classList.contains('is-visible')) {
      if (e.target.closest('#hy-modal-close') || e.target.classList.contains('hy-modal-backdrop')) {
        closeModal();
        return;
      }
      // Variant pill click → select + swap image (NO immediate add-to-cart, matches PDP)
      var pill = e.target.closest('.hy-modal-price-pill');
      if (pill && !pill.disabled && !pill.hasAttribute('aria-disabled')) {
        e.preventDefault();
        document.querySelectorAll('.hy-modal-price-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var prod = window.hytzV2Products[currentHandle];
        if (prod && pill.dataset.size) {
          currentSize = pill.dataset.size;
          setImage(pill.dataset.size, prod);
        }
        return;
      }
      // Add to Cart button → submit currently-selected variant
      var atcBtn = e.target.closest('#hy-modal-cart-btn');
      if (atcBtn) {
        e.preventDefault();
        var selectedPill = document.querySelector('.hy-modal-price-pill.is-selected');
        if (selectedPill && selectedPill.dataset.variantId) {
          addToCart(selectedPill.dataset.variantId, atcBtn);
        }
        return;
      }
      return; // any other click inside modal: do nothing
    }
    // Lineup card click → open modal
    // Scoped to component classes that should trigger the flip-modal.
    // NOT bare [data-handle] (overmatches on PDP / ingredient cards / etc).
    var srcCard = e.target.closest('.hy-lineup-card[data-handle], .hytz-cart-empty-row[data-handle]');
    if (srcCard) {
      if (e.target.closest('a[href]')) return;
      e.preventDefault();
      openModal(srcCard.dataset.handle, srcCard);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-visible')) closeModal();
    // Keyboard open for role="button" lineup cards — scoped same as click.
    if ((e.key === 'Enter' || e.key === ' ') && !modal.classList.contains('is-visible')) {
      var t = e.target;
      if (t && t.classList && (t.classList.contains('hy-lineup-card') || t.classList.contains('hytz-cart-empty-row')) && t.hasAttribute('data-handle')) {
        e.preventDefault();
        openModal(t.dataset.handle, t);
      }
    }
  });

  // Mobile scroll-hint: hide once user scrolls the right panel
  var scrollEl = document.getElementById('hy-modal-scroll');
  var hint = document.getElementById('hy-modal-scroll-hint');
  if (scrollEl && hint) {
    scrollEl.addEventListener('scroll', function () {
      if (scrollEl.scrollTop > 20) {
        hint.classList.add('is-hidden');
        modal.classList.add('has-scrolled');
      }
    }, { passive: true });
  }

  // Cart add via Shopify AJAX
  function addToCart(variantId, btn) {
    var msg = document.getElementById('hy-modal-cart-msg');
    btn.style.opacity = '0.6';
    if (btn.tagName === 'BUTTON') btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.style.opacity = '';
        if (btn.tagName === 'BUTTON') btn.disabled = false;
        if (data && data.status) {
          if (msg) { msg.textContent = '✗ ' + (data.description || 'Could not add'); msg.classList.add('is-visible', 'is-error'); setTimeout(function(){msg.classList.remove('is-visible', 'is-error');},2400); }
          return;
        }
        if (msg) {
          msg.textContent = '✓ Added to cart';
          msg.classList.add('is-visible', 'is-success-pop');
          setTimeout(function () {
            msg.classList.remove('is-visible', 'is-success-pop');
          }, 2200);
        }
        if (typeof window.hytzRefreshCart === 'function') {
          window.hytzRefreshCart();
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('.hytz-cart-count').forEach(function (el) {
              el.textContent = c.item_count;
            });
          });
        }
        // On the cart page itself, the Liquid-rendered line items need a full
        // reload to reflect the new state — cart markup isn't AJAX-swapped.
        if (/^\/cart\/?$/.test(window.location.pathname)) {
          setTimeout(function () { window.location.reload(); }, 900);
          return;
        }
        // Close modal and open cart drawer for strong visual confirmation.
        // 700ms lets the success pop animation play before transitioning.
        setTimeout(function () {
          if (typeof closeModal === 'function') closeModal();
          if (typeof window.hytzOpenCart === 'function') window.hytzOpenCart();
        }, 700);
      })
      .catch(function () {
        btn.style.opacity = '';
        if (btn.tagName === 'BUTTON') btn.disabled = false;
        if (msg) {
          msg.textContent = '✗ Could not add';
          msg.classList.add('is-visible', 'is-error');
          setTimeout(function () { msg.classList.remove('is-visible', 'is-error'); }, 2400);
        }
      });
  }
})();

/* ============================================================
   Accordion behavior: multiple-open allowed (Sol pref, 2026-04-23).
   Previously had sibling-close logic here — reverted. Native <details>
   default behavior handles the rest (each toggles independently).
   ============================================================ */

/* ============================================================
   PDP — Product Detail Page behaviors
   Session 10 (2026-04-23) — v3 rebuild
   ============================================================ */
(function () {
  var pdp = document.querySelector('.hy-pdp');
  if (!pdp) return;

  var handle = pdp.getAttribute('data-handle');
  var mainImg = document.getElementById('hy-pdp-main-img');
  var variantInput = document.getElementById('hy-pdp-variant-input');
  var cartForm = document.getElementById('hy-pdp-cart-form');
  var cartBtn = document.getElementById('hy-pdp-cart-btn');
  var cartMsg = document.getElementById('hy-pdp-cart-msg');
  var cartBtnText = cartBtn ? cartBtn.querySelector('.hy-pdp-cart-btn-text') : null;

  // ---- Render supplement facts as an inline TABLE (v3 — no accordion) ----
  if (window.hytzPdpSuppFacts && window.hytzPdpSuppFacts[handle]) {
    var data = window.hytzPdpSuppFacts[handle];
    var tbody = document.getElementById('hy-pdp-supp-tbody-' + handle);
    if (tbody && data && data.facts) {
      var rows = '';
      data.facts.forEach(function (f) {
        rows += '<tr><td>' + f.name + '</td><td>' + f.amount + '</td><td>' + f.dv + '</td></tr>';
      });
      tbody.innerHTML = rows;
    }
    // Lab potency table — uses claimed amount as both claimed + tested until real data wires in.
    var labBody = document.getElementById('hy-pdp-lab-tbody-' + handle);
    if (labBody && data && data.facts) {
      var labRows = '';
      data.facts.forEach(function (f) {
        labRows += '<tr>' +
          '<td>' + f.name + '</td>' +
          '<td>' + f.amount + '</td>' +
          '<td>' + f.amount + '</td>' +
          '<td><span class="hy-pdp-lab-pass">✓ Pass</span></td>' +
        '</tr>';
      });
      labBody.innerHTML = labRows;
    }
  }

  // ---- Shared main-image swap helper (fade-swap with decode gate) ----
  var stickyThumbImg = document.getElementById('hy-pdp-sticky-thumb-img');
  function swapMainImage(url) {
    if (!mainImg || !url) return;
    if (url === mainImg.src || mainImg.src.indexOf(url) !== -1) {
      // Still keep sticky thumb in sync even if main is already right
      if (stickyThumbImg && stickyThumbImg.src !== url) stickyThumbImg.src = url;
      return;
    }
    mainImg.classList.add('is-swapping');
    var next = new Image();
    next.onload = function () {
      mainImg.src = url;
      if (stickyThumbImg) stickyThumbImg.src = url;
      requestAnimationFrame(function () { mainImg.classList.remove('is-swapping'); });
    };
    next.onerror = function () { mainImg.classList.remove('is-swapping'); };
    next.src = url;
  }

  // Sync the product-image thumbnail rail to a given main-image URL (if any matches).
  // Leaves thumb state alone when nothing matches — prevents a stale "active" thumb
  // on variants whose image isn't in the product gallery.
  function syncThumbsToUrl(url) {
    var thumbsList = pdp.querySelectorAll('.hy-pdp-gallery-thumb');
    if (!thumbsList.length || !url) return;
    var match = null;
    thumbsList.forEach(function (t) {
      if (t.dataset.full === url) match = t;
    });
    if (!match) return;
    thumbsList.forEach(function (t) {
      var isActive = t === match;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  // ---- Variant pill selection ----
  var pills = pdp.querySelectorAll('.hy-pdp-price-pill');
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.hasAttribute('disabled')) return;
      pills.forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      if (variantInput && pill.dataset.variantId) {
        variantInput.value = pill.dataset.variantId;
      }
      // Swap main gallery image + sticky thumb to this variant's image (if available)
      if (pill.dataset.variantImage) {
        swapMainImage(pill.dataset.variantImage);
        syncThumbsToUrl(pill.dataset.variantImage);
      }
      // Sync gallery tab if size matches (legacy pack-size tabs)
      var size = pill.dataset.size;
      var tab = pdp.querySelector('.hy-pdp-gallery-tab[data-size="' + size + '"]');
      if (tab) syncGalleryTabs(tab);
    });
  });

  // ---- Preload all variant images so the pill → gallery swap is instant ----
  (function preloadVariantImages() {
    var seen = {};
    pills.forEach(function (p) {
      var u = p.dataset.variantImage;
      if (u && !seen[u]) { seen[u] = 1; var im = new Image(); im.src = u; }
    });
  })();

  // ---- Legacy: gallery pack-size tabs (kept for backward-compat on SKUs without real images) ----
  var tabs = pdp.querySelectorAll('.hy-pdp-gallery-tab');
  function syncGalleryTabs(activeTab) {
    tabs.forEach(function (t) {
      var isActive = t === activeTab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    if (!mainImg) return;
    var size = activeTab.dataset.size;
    var url = mainImg.getAttribute('data-' + size);
    if (!url || url === mainImg.src) return;
    mainImg.classList.add('is-swapping');
    var next = new Image();
    next.onload = function () {
      mainImg.src = url;
      requestAnimationFrame(function () { mainImg.classList.remove('is-swapping'); });
    };
    next.onerror = function () { mainImg.classList.remove('is-swapping'); };
    next.src = url;
  }
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      syncGalleryTabs(tab);
      var matchingPill = pdp.querySelector('.hy-pdp-price-pill[data-size="' + tab.dataset.size + '"]');
      if (matchingPill && !matchingPill.hasAttribute('disabled')) {
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        matchingPill.classList.add('is-selected');
        if (variantInput && matchingPill.dataset.variantId) {
          variantInput.value = matchingPill.dataset.variantId;
        }
      }
    });
  });

  // ---- v4: Product image thumbnails (click to swap main image) ----
  var thumbs = pdp.querySelectorAll('.hy-pdp-gallery-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.dataset.full;
      thumbs.forEach(function (t) {
        var isActive = t === thumb;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (full) swapMainImage(full);
    });
  });

  // ---- Round 6: Gallery lightbox — square modal with zoom (scroll, pinch, double-click, pan). ----
  (function () {
    var gallery = document.getElementById('hy-pdp-gallery-main');
    var lightbox = document.getElementById('hy-pdp-lightbox');
    var lbCard = document.getElementById('hy-pdp-lightbox-card');
    var lbImg = document.getElementById('hy-pdp-lightbox-img');
    var lbImgWrap = document.getElementById('hy-pdp-lightbox-img-wrap');
    var lbClose = document.getElementById('hy-pdp-lightbox-close');
    var lbZoomIn = document.getElementById('hy-pdp-lightbox-zoom-in');
    var lbZoomOut = document.getElementById('hy-pdp-lightbox-zoom-out');
    var lbZoomReset = document.getElementById('hy-pdp-lightbox-zoom-reset');
    var lbZoomLevel = document.getElementById('hy-pdp-lightbox-zoom-level');
    if (!gallery || !lightbox || !lbCard || !lbImg || !lbImgWrap) return;

    var sourceEl = null;
    var lastFocus = null;

    // Zoom state
    var scale = 1;
    var minScale = 1;
    var maxScale = 4;
    var tx = 0;  // translate x (px) applied on top of scale
    var ty = 0;
    var isPanning = false;
    var panStartX = 0;
    var panStartY = 0;
    var panStartTx = 0;
    var panStartTy = 0;

    // Pinch state (touch)
    var pinchActive = false;
    var pinchStartDist = 0;
    var pinchStartScale = 1;

    function computeFinalRect() {
      // Round 6: SQUARE modal at 1:1 aspect. Desktop: min(85vmin, 40rem). Mobile: min(92vmin, 32rem).
      var isMobile = window.innerWidth <= 640;
      var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      var vmin = Math.min(window.innerWidth, window.innerHeight);
      var size;
      if (isMobile) {
        size = Math.min(vmin * 0.92, rem * 32);
      } else {
        size = Math.min(vmin * 0.85, rem * 40);
      }
      return {
        left: Math.max(16, (window.innerWidth - size) / 2),
        top: Math.max(16, (window.innerHeight - size) / 2),
        width: size,
        height: size
      };
    }

    function applyTransform() {
      lbImg.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
      if (lbZoomLevel) lbZoomLevel.textContent = Math.round(scale * 100) + '%';
      lbImgWrap.classList.toggle('is-zoomed', scale > 1);
      if (lbZoomIn) lbZoomIn.disabled = scale >= maxScale - 0.001;
      if (lbZoomOut) lbZoomOut.disabled = scale <= minScale + 0.001;
    }
    function resetZoom() {
      scale = 1;
      tx = 0;
      ty = 0;
      applyTransform();
    }
    function clampPan() {
      // Limit pan so image stays reasonably within the wrap
      var wrapRect = lbImgWrap.getBoundingClientRect();
      var imgRect = lbImg.getBoundingClientRect();
      // Max offset each axis = (scaled image dim − wrap dim) / 2
      var maxX = Math.max(0, (imgRect.width - wrapRect.width) / 2);
      var maxY = Math.max(0, (imgRect.height - wrapRect.height) / 2);
      if (tx > maxX) tx = maxX;
      if (tx < -maxX) tx = -maxX;
      if (ty > maxY) ty = maxY;
      if (ty < -maxY) ty = -maxY;
    }
    // Zoom centered on a point within the wrap (e.g. cursor / pinch midpoint)
    function zoomAt(nextScale, originX, originY) {
      nextScale = Math.max(minScale, Math.min(maxScale, nextScale));
      if (nextScale === scale) return;
      var wrapRect = lbImgWrap.getBoundingClientRect();
      // Point relative to wrap center
      var cx = originX - (wrapRect.left + wrapRect.width / 2);
      var cy = originY - (wrapRect.top + wrapRect.height / 2);
      var ratio = nextScale / scale;
      // Adjust translate so the point under the cursor stays fixed
      tx = cx - (cx - tx) * ratio;
      ty = cy - (cy - ty) * ratio;
      scale = nextScale;
      clampPan();
      applyTransform();
    }

    function openLightbox(srcEl, imgUrl) {
      if (!imgUrl) return;
      sourceEl = srcEl;
      lastFocus = document.activeElement;
      lbImg.src = imgUrl;
      resetZoom();

      var rect = srcEl.getBoundingClientRect();
      var finalRect = computeFinalRect();

      lightbox.classList.add('is-visible', 'is-opening');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Position card at source, no transition
      lbCard.style.transition = 'none';
      lbCard.style.left = rect.left + 'px';
      lbCard.style.top = rect.top + 'px';
      lbCard.style.width = rect.width + 'px';
      lbCard.style.height = rect.height + 'px';
      lbCard.style.transform = 'rotateY(0deg)';
      lbCard.offsetHeight; // reflow

      // Animate to square + 360° flip
      lbCard.style.transition = '';
      requestAnimationFrame(function () {
        lbCard.style.left = finalRect.left + 'px';
        lbCard.style.top = finalRect.top + 'px';
        lbCard.style.width = finalRect.width + 'px';
        lbCard.style.height = finalRect.height + 'px';
        lbCard.style.transform = 'rotateY(360deg)';
      });

      setTimeout(function () {
        lightbox.classList.remove('is-opening');
        if (lbClose) lbClose.focus();
      }, 600);
    }

    function closeLightbox() {
      if (!sourceEl) return;
      lightbox.classList.add('is-closing');
      var rect = sourceEl.getBoundingClientRect();
      setTimeout(function () {
        lbCard.style.left = rect.left + 'px';
        lbCard.style.top = rect.top + 'px';
        lbCard.style.width = rect.width + 'px';
        lbCard.style.height = rect.height + 'px';
        lbCard.style.transform = 'rotateY(0deg)';
      }, 100);
      setTimeout(function () {
        lightbox.classList.remove('is-visible');
        lightbox.classList.remove('is-closing');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        lbCard.style.transition = 'none';
        lbCard.style.left = '';
        lbCard.style.top = '';
        lbCard.style.width = '';
        lbCard.style.height = '';
        lbCard.style.transform = '';
        sourceEl = null;
        resetZoom();  // Reset on close
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 750);
    }

    // Click main gallery area → open lightbox (accepts img OR zoom-hint icon clicks)
    gallery.addEventListener('click', function (e) {
      e.preventDefault();
      var imgEl = gallery.querySelector('img');
      openLightbox(gallery, imgEl ? imgEl.src : '');
    });

    // Dismiss: X button, backdrop (but NOT the card interior — that's where zoom happens)
    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('#hy-pdp-lightbox-close') || e.target.hasAttribute('data-lightbox-dismiss')) {
        closeLightbox();
      }
    });

    // Escape key + Tab focus trap
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-visible')) {
        closeLightbox();
      }
      if (e.key === 'Tab' && lightbox.classList.contains('is-visible') && !lightbox.classList.contains('is-opening')) {
        e.preventDefault();
        if (lbClose) lbClose.focus();
      }
    });

    // Resize → reposition if open (and re-clamp pan)
    window.addEventListener('resize', function () {
      if (!lightbox.classList.contains('is-visible') || lightbox.classList.contains('is-opening') || lightbox.classList.contains('is-closing')) return;
      var finalRect = computeFinalRect();
      lbCard.style.left = finalRect.left + 'px';
      lbCard.style.top = finalRect.top + 'px';
      lbCard.style.width = finalRect.width + 'px';
      lbCard.style.height = finalRect.height + 'px';
      clampPan();
      applyTransform();
    });

    // Zoom button controls
    if (lbZoomIn) lbZoomIn.addEventListener('click', function () {
      var wrapRect = lbImgWrap.getBoundingClientRect();
      zoomAt(scale + 0.5, wrapRect.left + wrapRect.width / 2, wrapRect.top + wrapRect.height / 2);
    });
    if (lbZoomOut) lbZoomOut.addEventListener('click', function () {
      var wrapRect = lbImgWrap.getBoundingClientRect();
      zoomAt(scale - 0.5, wrapRect.left + wrapRect.width / 2, wrapRect.top + wrapRect.height / 2);
    });
    if (lbZoomReset) lbZoomReset.addEventListener('click', resetZoom);

    // Scroll wheel zoom (zoom at pointer)
    lbImgWrap.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = -Math.sign(e.deltaY) * 0.25;
      zoomAt(scale + delta, e.clientX, e.clientY);
    }, { passive: false });

    // Double-click toggle 1x ↔ 2x at cursor
    lbImgWrap.addEventListener('dblclick', function (e) {
      if (scale > 1) {
        resetZoom();
      } else {
        zoomAt(2, e.clientX, e.clientY);
      }
    });

    // Pan on pointer drag (when zoomed)
    lbImgWrap.addEventListener('pointerdown', function (e) {
      // Two+ pointers → pinch path
      if (e.pointerType === 'touch') return;
      if (scale <= 1) return;
      isPanning = true;
      panStartX = e.clientX;
      panStartY = e.clientY;
      panStartTx = tx;
      panStartTy = ty;
      lbImgWrap.classList.add('is-panning');
      try { lbImgWrap.setPointerCapture(e.pointerId); } catch (_) {}
    });
    lbImgWrap.addEventListener('pointermove', function (e) {
      if (!isPanning) return;
      tx = panStartTx + (e.clientX - panStartX);
      ty = panStartTy + (e.clientY - panStartY);
      clampPan();
      applyTransform();
    });
    function endPan(e) {
      if (!isPanning) return;
      isPanning = false;
      lbImgWrap.classList.remove('is-panning');
      try { lbImgWrap.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    lbImgWrap.addEventListener('pointerup', endPan);
    lbImgWrap.addEventListener('pointercancel', endPan);
    lbImgWrap.addEventListener('pointerleave', endPan);

    // Pinch-to-zoom (touch) — use native TouchEvent for 2-finger gesture
    var activeTouches = {};
    function touchDist() {
      var ids = Object.keys(activeTouches);
      if (ids.length < 2) return 0;
      var a = activeTouches[ids[0]];
      var b = activeTouches[ids[1]];
      var dx = a.x - b.x, dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function touchMid() {
      var ids = Object.keys(activeTouches);
      if (ids.length < 2) return { x: 0, y: 0 };
      var a = activeTouches[ids[0]];
      var b = activeTouches[ids[1]];
      return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    }
    lbImgWrap.addEventListener('touchstart', function (e) {
      for (var i = 0; i < e.changedTouches.length; i++) {
        var t = e.changedTouches[i];
        activeTouches[t.identifier] = { x: t.clientX, y: t.clientY };
      }
      if (Object.keys(activeTouches).length === 2) {
        pinchActive = true;
        pinchStartDist = touchDist();
        pinchStartScale = scale;
      } else if (Object.keys(activeTouches).length === 1 && scale > 1) {
        // Single-touch pan
        var t0 = e.changedTouches[0];
        isPanning = true;
        panStartX = t0.clientX;
        panStartY = t0.clientY;
        panStartTx = tx;
        panStartTy = ty;
        lbImgWrap.classList.add('is-panning');
      }
    }, { passive: true });
    lbImgWrap.addEventListener('touchmove', function (e) {
      for (var i = 0; i < e.changedTouches.length; i++) {
        var t = e.changedTouches[i];
        if (activeTouches[t.identifier]) {
          activeTouches[t.identifier].x = t.clientX;
          activeTouches[t.identifier].y = t.clientY;
        }
      }
      if (pinchActive && Object.keys(activeTouches).length >= 2) {
        e.preventDefault();
        var d = touchDist();
        if (pinchStartDist > 0) {
          var next = pinchStartScale * (d / pinchStartDist);
          var mid = touchMid();
          zoomAt(next, mid.x, mid.y);
        }
      } else if (isPanning && Object.keys(activeTouches).length === 1) {
        e.preventDefault();
        var t = e.changedTouches[0];
        tx = panStartTx + (t.clientX - panStartX);
        ty = panStartTy + (t.clientY - panStartY);
        clampPan();
        applyTransform();
      }
    }, { passive: false });
    function touchEnd(e) {
      for (var i = 0; i < e.changedTouches.length; i++) {
        delete activeTouches[e.changedTouches[i].identifier];
      }
      if (Object.keys(activeTouches).length < 2) pinchActive = false;
      if (Object.keys(activeTouches).length === 0) {
        isPanning = false;
        lbImgWrap.classList.remove('is-panning');
      }
    }
    lbImgWrap.addEventListener('touchend', touchEnd);
    lbImgWrap.addEventListener('touchcancel', touchEnd);

    // Initial UI state
    applyTransform();
  })();

  // ---- Sticky ATC (bottom pill) — round 4: pack pills (no qty), bidirectional sync with hero pills ----
  var sticky = document.getElementById('hy-pdp-sticky');
  var stickyCta = document.getElementById('hy-pdp-sticky-cta');
  var stickyPacks = sticky ? sticky.querySelectorAll('.hy-pdp-sticky-pack') : [];

  function syncStickySelectionFromSize(size) {
    stickyPacks.forEach(function (p) {
      var match = p.dataset.size === size;
      p.classList.toggle('is-selected', match);
      p.setAttribute('aria-checked', match ? 'true' : 'false');
    });
  }
  function syncHeroSelectionFromSize(size) {
    pills.forEach(function (p) {
      var match = p.dataset.size === size;
      p.classList.toggle('is-selected', match);
    });
  }

  // Hero pill click → reflect on sticky (price/variant handled by hero pill's own listener upstream)
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.hasAttribute('disabled')) return;
      syncStickySelectionFromSize(pill.dataset.size);
    });
  });

  // Sticky pack click → drive the hero pill (single source of truth for variant/image/tab sync)
  stickyPacks.forEach(function (pack) {
    pack.addEventListener('click', function () {
      if (pack.hasAttribute('disabled')) return;
      var size = pack.dataset.size;
      var heroPill = pdp.querySelector('.hy-pdp-price-pill[data-size="' + size + '"]');
      if (heroPill && !heroPill.hasAttribute('disabled')) {
        heroPill.click();  // triggers variant/image/tab sync + price update
      }
      syncStickySelectionFromSize(size);
    });
  });

  // Sticky CTA → submit the hero form (quantity stays at form default of 1)
  if (stickyCta && cartForm) {
    stickyCta.addEventListener('click', function () {
      cartForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  // Visibility: show sticky once the hero cart form scrolls above the viewport,
  // AND hide again when the FOOTER enters view (don't sit over the footer).
  // NOTE: tried using FAQ-passed-viewport-top here originally — but the FAQ
  // section ends ~600px before the max scroll position, so faqRect.bottom < 0
  // is mathematically unreachable. footer-top-in-view is the correct trigger
  // (effectively: "user has reached the bottom-of-content zone").
  if (sticky && cartForm) {
    var stickyTick = null;
    var pageFooter = document.querySelector('.hy-footer');
    function updateStickyVisibility() {
      stickyTick = null;
      var heroRect = cartForm.getBoundingClientRect();
      var heroPast = heroRect.bottom < 0;
      var footerInView = false;
      if (pageFooter) {
        var footerRect = pageFooter.getBoundingClientRect();
        // Footer top has entered the viewport bottom = user reached footer area
        footerInView = footerRect.top < window.innerHeight;
      }
      var shouldShow = heroPast && !footerInView;
      if (shouldShow) {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }
    function onScrollOrResize() {
      if (stickyTick !== null) return;
      stickyTick = requestAnimationFrame(updateStickyVisibility);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    updateStickyVisibility();  // initial check
  }

  // ---- Render ingredient spotlight cards (v3: image-forward tiles) ----
  if (window.hytzPdpIngredients && window.hytzPdpIngredients[handle]) {
    var track = document.getElementById('hy-pdp-ingredients-track-' + handle);
    var ingredients = window.hytzPdpIngredients[handle];
    if (track && ingredients && ingredients.length) {
      function escapeHtml(s) {
        if (s == null) return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      }
      var cardsHtml = '';
      ingredients.forEach(function (ing) {
        var placeholder = 'Ingredient image: ' + ing.name + ' — macro shot, product-color tinted';
        var metaHtml = '';
        if (ing.foundIn || ing.benefits) {
          metaHtml = '<div class="hy-pdp-ingredient-meta">';
          if (ing.foundIn) {
            metaHtml += '<div class="hy-pdp-ingredient-meta-row">' +
              '<span class="hy-pdp-ingredient-meta-label">Found in</span>' +
              '<span class="hy-pdp-ingredient-meta-value">' + escapeHtml(ing.foundIn) + '</span>' +
              '</div>';
          }
          if (ing.benefits) {
            metaHtml += '<div class="hy-pdp-ingredient-meta-row">' +
              '<span class="hy-pdp-ingredient-meta-label">Benefits</span>' +
              '<span class="hy-pdp-ingredient-meta-value">' + escapeHtml(ing.benefits) + '</span>' +
              '</div>';
          }
          metaHtml += '</div>';
        }
        var slug = ing.image || '';
        var imgHtml = '';
        var imgClass = 'hy-pdp-ingredient-image';
        if (slug && window.hytzAssetBase) {
          imgHtml = '<img src="' + window.hytzAssetBase + 'ingredient-' + escapeHtml(slug) + '.png" alt="' + escapeHtml(ing.name) + '" loading="lazy">';
          imgClass += ' hy-pdp-ingredient-image--has-img';
        }
        cardsHtml += '<article class="hy-pdp-ingredient-card">' +
          '<div class="' + imgClass + '" data-placeholder="' + escapeHtml(placeholder) + '" data-ingredient-slug="' + escapeHtml(slug) + '">' + imgHtml + '</div>' +
          '<div class="hy-pdp-ingredient-body">' +
            '<div class="hy-pdp-ingredient-role">' + escapeHtml(ing.role) + '</div>' +
            '<h3 class="hy-pdp-ingredient-name">' + escapeHtml(ing.name) + '</h3>' +
            '<div class="hy-pdp-ingredient-amount">' + escapeHtml(ing.amount) + '</div>' +
            '<p class="hy-pdp-ingredient-blurb">' + escapeHtml(ing.blurb) + '</p>' +
            metaHtml +
          '</div>' +
        '</article>';
      });
      track.innerHTML = cardsHtml;
    }
    // Round 8: ingredient arrows now handled by the unified carousel setup below.
  }

  // ---- Add to cart (AJAX) ----
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value) return;
      var qtyInput = cartForm.querySelector('input[name="quantity"]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (cartBtn) { cartBtn.disabled = true; cartBtn.style.opacity = '0.6'; }
      if (cartMsg) { cartMsg.classList.remove('is-visible', 'is-error'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantInput.value, 10), quantity: qty }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (cartBtn) { cartBtn.disabled = false; cartBtn.style.opacity = ''; }
          if (data && data.status) {
            if (cartMsg) {
              cartMsg.textContent = '✗ ' + (data.description || 'Could not add');
              cartMsg.classList.add('is-visible', 'is-error');
              setTimeout(function () { cartMsg.classList.remove('is-visible'); }, 2800);
            }
            return;
          }
          if (cartMsg) {
            cartMsg.textContent = '✓ Added to cart';
            cartMsg.classList.add('is-visible');
            setTimeout(function () { cartMsg.classList.remove('is-visible'); }, 2400);
          }
          if (typeof window.hytzRefreshCart === 'function') {
            window.hytzRefreshCart();
          } else {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('.hytz-cart-count').forEach(function (el) {
                el.textContent = c.item_count;
              });
            });
          }
          // Open mini cart drawer for visual confirmation. Slight delay so the
          // cart count refresh runs first and the drawer opens with fresh data.
          if (typeof window.hytzOpenCart === 'function') {
            setTimeout(function () { window.hytzOpenCart(); }, 350);
          }
        })
        .catch(function () {
          if (cartBtn) { cartBtn.disabled = false; cartBtn.style.opacity = ''; }
          if (cartMsg) {
            cartMsg.textContent = '✗ Could not add';
            cartMsg.classList.add('is-visible', 'is-error');
            setTimeout(function () { cartMsg.classList.remove('is-visible'); }, 2800);
          }
        });
    });
  }

  // ---- Round 8: Unified infinite carousel system (Option A — cloned-edges
  //      native-scroll with idle-reposition) + line indicators.
  //
  //      TRUE infinite: the user scrolls right past the last card and the FIRST
  //      card appears naturally to the right (because we pre-clone a full copy
  //      of the originals both before and after the real set). When scroll
  //      becomes idle (140ms), we silently reposition scrollLeft back to the
  //      equivalent position in the ORIGINALS zone so the user can keep going
  //      indefinitely in either direction.
  //
  //      Line indicators track which ORIGINAL index is most-visible at any
  //      scroll position, regardless of which clone set is currently on-screen.
  //
  //      Applied to ALL four PDP carousels — reviews works the same way at
  //      every viewport, mobile scrollers work when they actually overflow. ----
  (function () {
    // Option C (round 8.1): fully layout-aware init/teardown.
    // A scroller is "active" only when its CURRENT computed layout is an
    // overflowing horizontal scroller (flex/grid with overflow-x: auto|scroll
    // AND scrollWidth > clientWidth). We inject clones + wire listeners only
    // when active, and we tear them down (remove clones, unwire) when the
    // layout flips back to a static grid (e.g. mobile → desktop resize).
    //
    // State is tracked via `data-carousel-state="active"|"inactive"` on the
    // scroller so setup/teardown are idempotent.

    // Registry of { scroller, config, teardown } so the debounced resize
    // handler can re-evaluate each carousel on viewport changes.
    var carousels = [];

    function isHorizontalScroller(scroller) {
      var cs = getComputedStyle(scroller);
      var isFlex = cs.display === 'flex' && /auto|scroll/.test(cs.overflowX);
      var isGrid = /grid/.test(cs.display) && /auto|scroll/.test(cs.overflowX);
      if (!isFlex && !isGrid) return false;
      // Only treat as a scroller if it actually overflows. Story-panels &
      // lineup on desktop are display:grid (no overflow-x) — this second
      // check is belt-and-suspenders for any future layout that keeps
      // overflow-x:auto but has no actual overflow.
      return scroller.scrollWidth > scroller.clientWidth + 1;
    }

    function teardownCarousel(scroller, linesContainer) {
      if (!scroller || scroller.dataset.carouselState !== 'active') return;
      // Remove all cloned children (lead + trail).
      var clones = scroller.querySelectorAll('[data-hy-clone]');
      clones.forEach(function (c) { c.parentNode && c.parentNode.removeChild(c); });
      // Invoke stored teardown (unwires scroll/arrow listeners).
      if (typeof scroller._hyCarouselTeardown === 'function') {
        try { scroller._hyCarouselTeardown(); } catch (e) { /* noop */ }
        scroller._hyCarouselTeardown = null;
      }
      // Clear lines container + state flags.
      if (linesContainer) {
        linesContainer.innerHTML = '';
        linesContainer.style.display = 'none';
      }
      scroller.dataset.carouselState = 'inactive';
      delete scroller.dataset.hyCarouselInit;
      scroller.style.visibility = '';
      scroller.style.scrollBehavior = '';
      // Reset scroll position so the static grid doesn't render scrolled off.
      scroller.scrollLeft = 0;
    }

    function setupCarousel(config) {
      var scroller = config.scroller;
      var linesContainer = config.lines;
      var navs = config.navs || [];
      if (!scroller) return;

      // Register once so resize re-evaluation can reach this carousel.
      if (!scroller.dataset.hyCarouselRegistered) {
        scroller.dataset.hyCarouselRegistered = '1';
        carousels.push({ scroller: scroller, config: config });
      }

      // Bail if already active (e.g. second call for ingredient track after
      // JS-rendered cards populate).
      if (scroller.dataset.carouselState === 'active') return;

      // LAYOUT GUARD: only proceed if currently an overflowing scroller.
      // On desktop for story-panels / lineup, this is false → no DOM mutations,
      // no listeners, clean grid renders.
      if (!isHorizontalScroller(scroller)) {
        if (linesContainer) { linesContainer.innerHTML = ''; linesContainer.style.display = 'none'; }
        scroller.dataset.carouselState = 'inactive';
        return;
      }

      var originalKids = Array.from(scroller.children).filter(function (c) {
        // Skip leftover clones (defensive — teardown should remove them).
        if (c.dataset && c.dataset.hyClone) return false;
        // Skip decorative/hidden children (e.g. the story-panel connector,
        // which is display:none on mobile but still a flex child). Without
        // this filter they get counted as cards, which throws off n, step,
        // line-indicator count, and the modIdx mapping.
        if (c.getBoundingClientRect().width <= 0) return false;
        return true;
      });
      if (originalKids.length < 2) {
        if (linesContainer) renderLines(linesContainer, originalKids.length, 0, null);
        scroller.dataset.carouselState = 'inactive';
        return;
      }

      scroller.dataset.hyCarouselInit = '1';
      scroller.dataset.carouselState = 'active';
      var n = originalKids.length;

      // Tag each original with its target indicator index so updateActive
      // can read it directly off the card (or its clone) instead of relying
      // on `bestIdx % n`, which is wrong when non-card children sit in the
      // flex flow (connector etc.).
      originalKids.forEach(function (k, idx) { k.dataset.hyIdx = String(idx); });

      // Clone full set before AND after originals: [clones | originals | clones]
      var leadFrag = document.createDocumentFragment();
      var trailFrag = document.createDocumentFragment();
      originalKids.forEach(function (k) {
        var srcIdx = k.dataset.hyIdx;
        var leadClone = k.cloneNode(true);
        leadClone.setAttribute('aria-hidden', 'true');
        leadClone.dataset.hyClone = 'lead';
        leadClone.dataset.hyIdx = srcIdx;
        leadFrag.appendChild(leadClone);
        var trailClone = k.cloneNode(true);
        trailClone.setAttribute('aria-hidden', 'true');
        trailClone.dataset.hyClone = 'trail';
        trailClone.dataset.hyIdx = srcIdx;
        trailFrag.appendChild(trailClone);
      });
      scroller.insertBefore(leadFrag, originalKids[0]);
      scroller.appendChild(trailFrag);

      // Compute step: average width of originals + gap.
      function step() {
        var ref = originalKids[0];
        if (!ref) return 0;
        var r = ref.getBoundingClientRect();
        var cs = getComputedStyle(scroller);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return r.width + gap;
      }

      // Initial position: start of the ORIGINALS zone.
      scroller.style.visibility = 'hidden';
      function initPos() {
        var s = step();
        scroller.style.scrollBehavior = 'auto';
        scroller.scrollLeft = s * n;
        requestAnimationFrame(function () {
          scroller.style.scrollBehavior = '';
          scroller.style.visibility = '';
        });
        updateActive();
      }
      requestAnimationFrame(function () { requestAnimationFrame(initPos); });

      // Silent reposition when user has scrolled into clone zones AND is idle.
      var scrollEndT = null;
      function maybeReposition() {
        var s = step();
        if (s <= 0) return;
        var width = s * n;
        var leadEnd = s * n;
        var trailStart = s * (2 * n);
        var sl = scroller.scrollLeft;
        if (sl >= trailStart) {
          scroller.style.scrollBehavior = 'auto';
          scroller.scrollLeft = sl - width;
          requestAnimationFrame(function () { scroller.style.scrollBehavior = ''; });
        } else if (sl < leadEnd - 1) {
          scroller.style.scrollBehavior = 'auto';
          scroller.scrollLeft = sl + width;
          requestAnimationFrame(function () { scroller.style.scrollBehavior = ''; });
        }
      }

      // Active-index tracking for line indicators.
      // Round 12 fix: branch on scroll-snap-align. Previous code assumed center-snap
      // for all scrollers, but the lineup uses start-snap — detection was off by one.
      var currentActive = 0;
      function updateActive() {
        var cards = scroller.children;
        if (!cards || !cards.length) return;
        var sRect = scroller.getBoundingClientRect();
        // Use an actual card (originalKids[0]) to read snap-align — cards[0]
        // can be a non-card decorative element with different snap behavior.
        var snapAlign = (originalKids[0] && getComputedStyle(originalKids[0]).scrollSnapAlign) || 'start';
        var isCenter = snapAlign.indexOf('center') !== -1;
        var referencePoint = isCenter ? sRect.left + sRect.width / 2 : sRect.left + 1; // small +1 bias so edge case doesn't double-count
        var bestCard = null;
        var bestDist = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var card = cards[i];
          // Only consider tagged cards — skips connector and other decoration.
          if (!card.dataset || card.dataset.hyIdx == null || card.dataset.hyIdx === '') continue;
          var cr = card.getBoundingClientRect();
          if (cr.width <= 0) continue;
          var cardPoint = isCenter ? cr.left + cr.width / 2 : cr.left;
          var d = Math.abs(cardPoint - referencePoint);
          if (d < bestDist) { bestDist = d; bestCard = card; }
        }
        if (!bestCard) return;
        var modIdx = parseInt(bestCard.dataset.hyIdx, 10) || 0;
        if (modIdx !== currentActive) {
          currentActive = modIdx;
          if (linesContainer) setActiveLine(linesContainer, modIdx);
          scroller.dataset.hyActive = String(modIdx);
        }
      }

      // Scroll handler (scoped so teardown can unwire).
      function onScroll() {
        updateActive();
        clearTimeout(scrollEndT);
        scrollEndT = setTimeout(maybeReposition, 140);
      }
      scroller.addEventListener('scroll', onScroll, { passive: true });

      // Arrow/nav click handlers (scoped for teardown).
      var navHandlers = [];
      navs.forEach(function (btn) {
        var h = function () {
          var s = step();
          if (s <= 0) return;
          var dir = btn.dataset.dir === 'next' ? 1 : -1;
          scroller.scrollBy({ left: dir * s, behavior: 'smooth' });
        };
        btn.addEventListener('click', h);
        navHandlers.push({ btn: btn, handler: h });
      });

      // Build line indicators.
      if (linesContainer) {
        renderLines(linesContainer, n, 0, function (idx) {
          var s = step();
          if (s <= 0) return;
          scroller.scrollTo({ left: s * (n + idx), behavior: 'smooth' });
        });
      }

      // Stash teardown closure so teardownCarousel can unwire listeners.
      scroller._hyCarouselTeardown = function () {
        scroller.removeEventListener('scroll', onScroll);
        navHandlers.forEach(function (nh) { nh.btn.removeEventListener('click', nh.handler); });
        clearTimeout(scrollEndT);
      };
    }

    // Debounced window resize → re-evaluate every registered carousel.
    // mobile → desktop: layout no longer scrolls → tear down clones/listeners.
    // desktop → mobile: layout becomes scroller → set up clones/listeners.
    // Same-state resize within active scroller: re-center on active card.
    var resizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        carousels.forEach(function (entry) {
          var sc = entry.scroller;
          var cfg = entry.config;
          var shouldBeActive = isHorizontalScroller(sc);
          var isActive = sc.dataset.carouselState === 'active';
          if (shouldBeActive && !isActive) {
            // Was static grid, now a scroller → set up.
            setupCarousel(cfg);
          } else if (!shouldBeActive && isActive) {
            // Was a scroller, now static grid → tear down completely.
            teardownCarousel(sc, cfg.lines);
          } else if (shouldBeActive && isActive) {
            // Stayed active — re-center scroll position on current active card.
            var kids = Array.from(sc.children).filter(function (c) {
              if (c.dataset && c.dataset.hyClone) return false;
              if (c.getBoundingClientRect().width <= 0) return false;
              return true;
            });
            var n = kids.length;
            if (!n) return;
            var ref = kids[0];
            var r = ref.getBoundingClientRect();
            var cs = getComputedStyle(sc);
            var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
            var s = r.width + gap;
            if (s <= 0) return;
            var active = parseInt(sc.dataset.hyActive || '0', 10) || 0;
            sc.style.scrollBehavior = 'auto';
            sc.scrollLeft = s * (n + active);
            requestAnimationFrame(function () { sc.style.scrollBehavior = ''; });
          }
        });
      }, 150);
    });

    function renderLines(container, count, active, onClick) {
      if (!container) return;
      // Clear existing
      container.innerHTML = '';
      if (!count || count < 1) return;
      // Hide the indicator strip entirely if there's only one slide.
      if (count < 2) { container.style.display = 'none'; return; }
      container.style.display = '';
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hy-pdp-scroll-line' + (i === active ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === active ? 'true' : 'false');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.dataset.idx = String(i);
        if (typeof onClick === 'function') {
          (function (idx) {
            btn.addEventListener('click', function () { onClick(idx); });
          })(i);
        }
        container.appendChild(btn);
      }
    }
    function setActiveLine(container, activeIdx) {
      if (!container) return;
      var lines = container.querySelectorAll('.hy-pdp-scroll-line');
      lines.forEach(function (ln, i) {
        var on = i === activeIdx;
        ln.classList.toggle('is-active', on);
        ln.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    // ----- Reviews carousel (all viewports) -----
    var reviewsStage = pdp.querySelector('.hy-pdp-reviews-v4-stage');
    if (reviewsStage) {
      setupCarousel({
        scroller: pdp.querySelector('#hy-pdp-reviews-v4-track'),
        lines: pdp.querySelector('.hy-pdp-reviews-v4-lines'),
        navs: Array.prototype.slice.call(reviewsStage.querySelectorAll('.hy-pdp-reviews-v4-nav'))
      });
      // Keyboard arrows on the stage (parity with round 6)
      reviewsStage.setAttribute('tabindex', '0');
      reviewsStage.addEventListener('keydown', function (e) {
        var track = reviewsStage.querySelector('#hy-pdp-reviews-v4-track');
        if (!track) return;
        var first = track.querySelector(':scope > *');
        if (!first) return;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        var s = first.getBoundingClientRect().width + gap;
        if (e.key === 'ArrowLeft') { track.scrollBy({ left: -s, behavior: 'smooth' }); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { track.scrollBy({ left: s, behavior: 'smooth' }); e.preventDefault(); }
      });
    }

    // ----- Mechanism story panels (mobile-only; grid on desktop so no scroll) -----
    // We still call setupCarousel; it no-ops if the scroller doesn't actually overflow.
    setupCarousel({
      scroller: pdp.querySelector('.hy-pdp-story-panels'),
      lines: pdp.querySelector('.hy-pdp-story-lines')
    });

    // ----- Ingredients scroller (both mobile + desktop; arrows on desktop) -----
    // NOTE: ingredient cards are rendered by JS earlier in this IIFE. By the time
    // we reach here they exist in the DOM, so setupCarousel can proceed.
    var ingWrap = pdp.querySelector('.hy-pdp-ingredients-scroller');
    setupCarousel({
      scroller: pdp.querySelector('.hy-pdp-ingredients-track'),
      lines: pdp.querySelector('.hy-pdp-ingredients-lines'),
      navs: ingWrap ? Array.prototype.slice.call(ingWrap.querySelectorAll('.hy-pdp-ingredients-arrow')) : []
    });

    // ----- Full lineup grid (horizontal scroller all viewports; arrows on desktop only) -----
    var recsWrap = pdp.querySelector('.hy-pdp-recs-wrap');
    setupCarousel({
      scroller: pdp.querySelector('.hy-pdp-recs-grid-v3'),
      lines: pdp.querySelector('.hy-pdp-recs-lines'),
      navs: recsWrap ? Array.prototype.slice.call(recsWrap.querySelectorAll('.hy-pdp-recs-nav')) : []
    });
  })();
})();

/* FYF sticky claim bar shim — keeps the special-offer email bar visible immediately on results load. */
(function hyFyfStickyClaimShim(){
  var raf=0;
  var syncing=false;
  function ensureCenteredStyles(){
    if(document.getElementById('hy-fyf-sticky-claim-shim-css')) return;
    var style=document.createElement('style');
    style.id='hy-fyf-sticky-claim-shim-css';
    style.textContent='.hy-ms-funnel-page .sticky-offer-bar .promo-email-field .btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;line-height:1!important;box-sizing:border-box!important}.hy-ms-funnel-page #stickyPromoSubmitBtn::after,.hy-ms-funnel-page #promoSubmitBtn::after{align-items:center!important;justify-content:center!important;text-align:center!important}';
    document.head.appendChild(style);
  }
  function isVariantB(root){return root&&root.getAttribute('data-ms-variant')==='b';}
  function footerBlocking(bar){
    var footer=document.querySelector('.shopify-section-group-footer-group, footer');
    var barHeight=bar.getBoundingClientRect().height||94;
    return !!(footer&&footer.getBoundingClientRect().top<=window.innerHeight-barHeight-10);
  }
  function sync(){
    raf=0;
    if(syncing) return;
    var root=document.querySelector('.hy-ms-funnel-page');
    var bar=document.getElementById('stickyOfferForm');
    if(!root||!bar) return;
    syncing=true;
    try{
      ensureCenteredStyles();
      var visible=isVariantB(root)&&root.classList.contains('results-mode')&&root.classList.contains('locator-inline-active')&&!root.classList.contains('offer-claimed')&&!footerBlocking(bar);
      if(visible){
        if(bar.hidden) bar.hidden=false;
        bar.classList.add('is-visible');
      }else{
        if(!bar.hidden) bar.hidden=true;
        bar.classList.remove('is-visible');
      }
    }finally{
      syncing=false;
    }
  }
  function schedule(){if(!raf) raf=requestAnimationFrame(sync);}
  function bind(){
    var root=document.querySelector('.hy-ms-funnel-page');
    if(!root||root.dataset.hyFyfStickyShimBound==='1') return;
    root.dataset.hyFyfStickyShimBound='1';
    ensureCenteredStyles();
    var observer=new MutationObserver(schedule);
    observer.observe(root,{attributes:true,attributeFilter:['class','data-ms-variant']});
    var bar=document.getElementById('stickyOfferForm');
    if(bar) observer.observe(bar,{attributes:true,attributeFilter:['hidden','class']});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    window.addEventListener('orientationchange',schedule);
    document.addEventListener('click',function(){setTimeout(schedule,60);setTimeout(schedule,320);},true);
    var ticks=0;
    var timer=setInterval(function(){schedule();ticks+=1;if(ticks>40) clearInterval(timer);},150);
    schedule();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bind,{once:true});
  else bind();
})();
